import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Tileset = ({
  height = 24,
  width = 24,
  color = colors.grey35,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M6.75,5.248v1.5a1.5,1.5,0,0,0,1.5,1.5h4.5a1.5,1.5,0,0,1,1.5,1.5v1.5"
    />
    <path
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M18.75,15.748v4.5a1.5,1.5,0,0,1-1.5,1.5h-3"
    />
    <rect
      stroke={colors.purple50}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x="0.75"
      y="18.748"
      width="13.5"
      height="4.5"
      rx="0.75"
      ry="0.75"
    />
    <rect
      stroke={colors.salmon50}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x="9.75"
      y="11.248"
      width="13.5"
      height="4.5"
      rx="0.75"
      ry="0.75"
    />
    <rect
      stroke={colors.cyan100}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x="0.75"
      y="0.748"
      width="13.5"
      height="4.5"
      rx="0.75"
      ry="0.75"
    />
  </SvgIcon>
);
